"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "simulateFileAccess", {
    enumerable: true,
    get: function() {
        return simulateFileAccess;
    }
});
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
const _fs = /*#__PURE__*/ _interop_require_default(require("fs"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function simulateFileAccess(logger, root, inputs, outputs) {
    logger.silly("Now probing and touching inputs and outputs");
    // Helper to get all directory parts up to root
    const getAllDirectoryParts = (filePath)=>{
        const parts = [];
        let dirPath = _path.default.dirname(filePath);
        while(dirPath !== "." && dirPath !== ""){
            parts.push(dirPath);
            dirPath = _path.default.dirname(dirPath);
        }
        return parts;
    };
    const inputDirectories = new Set();
    // read input files
    let fd;
    const buffer = Buffer.alloc(1);
    for (const input of inputs){
        try {
            const inputPath = _path.default.join(root, input);
            if (!_fs.default.lstatSync(inputPath).isDirectory()) {
                fd = _fs.default.openSync(inputPath, "r");
                // Simulate a file content read by reading 1 byte of the opened file handle
                _fs.default.readSync(fd, buffer, 0, 1, 0);
                _fs.default.closeSync(fd);
            } else {
                inputDirectories.add(input);
            }
        } catch (e) {
        // ignore
        }
        // Add all directory parts to the set
        getAllDirectoryParts(input).forEach((dir)=>inputDirectories.add(dir));
    }
    for (const directory of inputDirectories){
        try {
            // Simulate enumerating a directory
            _fs.default.readdirSync(_path.default.join(root, directory));
        } catch (e) {
        // ignore
        }
    }
    // touch output files
    const time = new Date();
    const outputDirectories = new Set();
    for (const output of outputs){
        // Add all directory parts to the set
        getAllDirectoryParts(output).forEach((dir)=>outputDirectories.add(dir));
        try {
            _fs.default.utimesSync(_path.default.join(root, output), time, time);
        } catch (e) {
        // ignore
        }
    }
    for (const directory of outputDirectories){
        try {
            _fs.default.utimesSync(_path.default.join(root, directory), time, time);
        } catch (e) {
        // ignore
        }
    }
}
